import { connect } from 'react-redux';
import TranslateNamePermission from '../../components/Common/TranslatePermission';


function mapStateToProps(state) {
    return {
        language: state.i18n.locale,
    }
}
export default connect(mapStateToProps, null)(TranslateNamePermission)



// WEBPACK FOOTER //
// ./master/jsx/containers/TranslatePermission/translate.jsx